import actionCreatorFactory from 'typescript-fsa';

import { Overwrite } from '@material-ui/types';
import { FormName } from '@topconagriculture/feed-types';

import reduxConfig from '../../config';
import { Operator, OperatorFormValues } from '../../../core/api/operator/operator.types';

const actionCreator = actionCreatorFactory(reduxConfig.appName + '/operator');

export const getOperatorsList = actionCreator.async<{}, Operator[]>('[GET_OPERATOR_LIST]');
export const getAllOperators = actionCreator.async<{}, Operator[]>('[GET_ALL_OPERATORS]');
export const createOperator = actionCreator.async<FormName, Operator>('[CREATE_OPERATOR]');
export const deleteOperator = actionCreator.async<{ id: Operator['id']; formName: FormName }, {}>('[DELETE_OPERATOR]');
export const updateOperator = actionCreator.async<
  { data: Overwrite<OperatorFormValues, { id: Operator['id'] }>; formName: FormName },
  Operator
>('[UPDATE_OPERATOR]');
